import React, { useEffect, useState, useRef } from "react";
import {
  Space,
  Button,
  Table,
  Radio,
  Form,
  Spin,
  Modal,
  message,
  Image,
  Drawer,
} from "antd";
import axios from "axios";
import API from "@/api";
import MxbsFormDetail from "../mxbsFormDetail";
function Mxbssh(props) {
  const { types, userInfo } = props;
  const [current, setCurrent] = useState(1);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(false);
  const [spinning, setSpinning] = useState(true);
  const [type, setType] = useState("all");
  const [refresh, setRefresh] = useState("");
  const [selectedRow, setSelectedRow] = useState({});
  const [dType, setDtype] = useState("add");
  const sqFormDetailRef = useRef();
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        API.mxbsCheckList +
          `?page=${current - 1}&size=${size}&status=${
            type === "all" ? "" : type
          }`
      )
      .then((res) => {
        setData(res?.data?.result?.data?.list || []);
        setTotal(res?.data?.result?.total || 0);
        setLoading(false);
        setSpinning(false);
      });
  }, [current, size, type, refresh]);

  const handleStatus = (status) => {
    if (status * 1 === 1) {
      return (
        <span
          style={{
            color: "#d9001ba5",
          }}
        >
          审核中
        </span>
      );
    } else if (status * 1 === 2) {
      return (
        <span
          style={{
            color: "#70b603a5",
          }}
        >
          通过
        </span>
      );
    } else if (status * 1 === 3) {
      return (
        <span
          style={{
            color: "#f59a23a5",
          }}
        >
          驳回
        </span>
      );
    } else if (status * 1 === 4) {
      return <span>已取消</span>;
    } else {
      return "";
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <div>
        <Form
          initialValues={{
            type: type,
          }}
        >
          <Form.Item label="状态">
            <Radio.Group
              options={[
                {
                  label: "全部",
                  value: "all",
                },
                {
                  label: "待审核",
                  value: "1",
                },
                {
                  label: "通过",
                  value: "2",
                },
                {
                  label: "驳回",
                  value: "3",
                },
              ]}
              value={type}
              onChange={(val) => {
                setType(val?.target?.value);
              }}
            />
          </Form.Item>
        </Form>
      </div>
      <Spin spinning={spinning}>
        <Table
          bordered
          dataSource={data}
           columns={[
            {
              title: "模型名称",
              dataIndex: "name",
            },
            {
              title: "模型类型",
              dataIndex: "categoryName",
            },
            {
            title:"精度/量化格式",
            dataIndex:"quantFormat"  
            },
            {
              title: "参数规模",
              dataIndex: "paramSize",
            },
            {
              title: "上下文长度",
              dataIndex: "context",
            },
            {
              title: "GPU数量",
              dataIndex: "gpuCount",
            },
            {
              title: "显存大小（GB）",
              dataIndex: "memSize",
            },
            {
                title:"申请人",
                dataIndex:"userName"
            },
            {
              title: "审核状态",
              dataIndex: "status",
              render(val) {
                return handleStatus(val);
              },
            },
            {
              title: "申请时间",
              dataIndex: "createTime",
            },

            {
              title: "操作",
              dataIndex: "id",
              render(val, row) {
                return (
                  <>
                    <Space>
                      {row?.status * 1 === 1 ? (
                        <>
                          <span
                            style={{
                              color: "#1890FF",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDtype("check");
                              setSelectedRow(row);
                              setOpen(true);
                            }}
                          >
                            审核
                          </span>
                        </>
                      ) : undefined}
                      <span
                        style={{
                          color: "#1890FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setDtype("see");
                          setSelectedRow(row);
                          setOpen(true);
                        }}
                      >
                        详情
                      </span>
                    </Space>
                  </>
                );
              },
            },
          ]}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: current,
            pageSize: size,
            onChange: (cur, pageSize) => {
              setCurrent(cur);
              setSize(pageSize);
            },
            total: total,
            showQuickJumper: true,
          }}
        />
      </Spin>

      <Drawer
        title={dType == "see" ? "申请详情" : "申请审核"}
        open={open}
        destroyOnHidden={true}
        onClose={() => {
          setOpen(false);
          setDtype("add");
          setSelectedRow({});
        }}
        width={"65%"}
        okText="确定"
        cancelText="取消"
        footer={
          dType === "see" ? (
            <>
              <Button
                onClick={() => {
                  setOpen(false);
                }}
              >
                关闭
              </Button>
            </>
          ) : (
            <Space>
              <Button
                onClick={() => {
                  setOpen(false);
                  setDtype("add");
                  setSelectedRow({});
                }}
              >
                关闭
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  const data = sqFormDetailRef?.current.getValue();
                  const verify = sqFormDetailRef?.current.verify();
                  console.log(verify);
                  verify
                    .then(() => {
                      for (const key in data) {
                        if (data[key]) {
                          data[key] = data[key];
                        } else {
                          data[key] = "";
                        }
                      }
                      data.id = selectedRow?.id;
                      axios.post(API.mxbsCheck, data).then((res) => {
                        if (res?.data?.resultCode === 0) {
                          message.success("审核成功");
                          setOpen(false);
                          setRefresh(Math.random());
                        } else {
                          message.error(res?.data?.errorMsg);
                        }
                      });
                    })
                    .catch(() => {});
                }}
              >
                确定
              </Button>
            </Space>
          )
        }
      >
        <MxbsFormDetail
          ref={sqFormDetailRef}
          userInfo={userInfo}
          selectedRow={selectedRow}
          types={types}
          type={dType}
        />
      </Drawer>
    </div>
  );
}

export default Mxbssh;
